/**
 * Generate a safe negative ID from a temp ID string
 * Returns a deterministic negative integer within Number.MAX_SAFE_INTEGER
 *
 * The legacy parseInt approach extracts too many digits from timestamps,
 * exceeding MAX_SAFE_INTEGER and causing comparison failures.
 * This hash-based approach ensures IDs are always safe.
 */
export function safeNegativeId(tempId: string): number {
  // Hash the temp ID string
  let hash = 0;
  for (let i = 0; i < tempId.length; i++) {
    hash = ((hash << 5) - hash) + tempId.charCodeAt(i);
    hash = hash & hash; // Convert to 32bit integer
  }

  // Normalize to ensure positive, non-zero value within safe range
  const HASH_RANGE = Math.floor(Number.MAX_SAFE_INTEGER / 1000);
  const normalized = ((hash >>> 0) % HASH_RANGE) || 1; // Never return 0
  return -normalized;
}

/**
 * Legacy unsafe calculation (for migration only)
 * DO NOT USE in new code - will be deleted after responses remapped
 *
 * This extracts digits from tempId which can exceed MAX_SAFE_INTEGER
 * causing precision loss and comparison failures.
 */
export function legacyNegativeId(tempId: string): number {
  return -Math.abs(parseInt(tempId.replace(/\D/g, '')) || Date.now());
}
